import { GET_LABELS, GET_LABELS_Name } from '../actions'
import axios from 'axios'

const PROXY = process.env.REACT_APP_URL + 'api/'

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
}

export const getLabels = () => async (dispatch) => {
  const res = await axios.get(PROXY + 'label/get-label')
  dispatch({
    type: GET_LABELS,
    payload: res.data.result,
  })
  return res
}

export const addLabel = (label) => async (dispatch) => {
  const body = JSON.stringify(label)
  return await axios.post(PROXY + 'label/add-label', body, config)
}

export const updateLabel = (label) => async (dispatch) => {
  const body = JSON.stringify(label)
  return await axios.post(PROXY + 'label/update-label', body, config)
}

export const deleteLabel = (_id) => async (dispatch) => {
  return await axios.delete(PROXY + 'label/delete-label/' + _id)
}
export const getLabelVersion = () => async (dispatch) => {
  const res = await axios.get(PROXY + "label/version");

  if(localStorage.getItem('owner-label-version')){
    if(localStorage.getItem('owner-label-version' ) != res.data.result.type_2_version){
    
      localStorage.setItem('owner-label-version' , res.data.result.type_2_version)
      dispatch(getLabelsName())
    }
  }
  else{
    localStorage.setItem('owner-label-version' , res.data.result.type_2_version)
  dispatch(getLabelsName())
  }
return res.data.result.type_2_version
}
export const getLabelsName =
  (language = 'en', type = 2, version = '', pl = '') =>
  async (dispatch) => {
    language = localStorage.getItem('Lng') || 'en'
    version = localStorage.getItem('ownerversion') || 0
    pl = localStorage.getItem('prevLangOwner') || 0
    const res = await axios.get(
      `${PROXY}label/get-label?language=${language}&type=${type}&version=${version}&pl=${pl}`
    )

    localStorage.setItem('ownerversion', res?.data?.result[0]?.version || 0)
    localStorage.setItem('prevLangOwner', language)

    if (res?.data?.result?.length > 0) {
      dispatch({
        type: GET_LABELS_Name,
        payload: res.data.result,
      })
    }
  }
